import { render, staticRenderFns } from "./ProductAnalysisDetail.vue?vue&type=template&id=41bf900e&scoped=true"
import script from "./ProductAnalysisDetail.vue?vue&type=script&lang=js"
export * from "./ProductAnalysisDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductAnalysisDetail.vue?vue&type=style&index=0&id=41bf900e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bf900e",
  null
  
)

export default component.exports